export default [
  {
    title: 'CORPORATE',
    icon: 'fas fa-th',
    children: [
      {
        path: '/admin/companies',
        title: 'Company Profile',
        permission: 'view-company-profiles'
      },
      {
        path: '/admin/branches',
        title: 'Branch Profile',
        permission: 'view-branches'
      },
      {
        path: '/admin/bank-profiles',
        title: 'Bank Profile',
        permission: 'view-bank-profiles'
      },
      {
        path: '/admin/address/districts',
        title: 'District',
        permission: 'view-districts'
      },
      {
        path: '/admin/address/communes',
        title: 'Commune',
        permission: 'view-communes'
      },
      {
        path: '/admin/address/villages',
        title: 'Village',
        permission: 'view-villages'
      }
    ]
  },
  {
    title: 'SETTING',
    icon: 'fas fa-cog',
    children: [
      {
        title: 'General',
        path: '/admin/settings',
        permission: 'view-settings'
      },
      {
        path: '/admin/promotions',
        title: 'Promotion',
        permission: 'view-promotions'
      },
      {
        path: '/admin/exchange-rates',
        title: 'Exchange Rate',
        permission: 'view-exchange-rates'
      },
      {
        path: '/admin/currencies',
        title: 'Currency',
        permission: 'view-currencies'
      },
      {
        path: '/admin/approval-request-flows',
        title: 'Approval Request Flow',
        permission: 'view-approval-request-flows'
      }
    ]
  },
  {
    icon: 'fas fa-business-time',
    title: 'menu.humanResource',
    children: [
      {
        title: 'menu.employeeManagement',
        children: [
          {
            path: '/admin/organizational-charts',
            title: 'menu.organizationalChart',
            permission: 'view-organizational-charts'
          },
          {
            path: '/admin/organizational-structures',
            title: 'menu.organizationalStructure',
            permission: 'view-organizational-structures'
          },
          {
            path: '/admin/job-levels',
            title: 'menu.jobLevel',
            permission: 'view-job-levels'
          },
          {
            path: '/admin/job-titles',
            title: 'menu.jobTitle',
            permission: 'view-job-titles'
          },
          {
            path: '/admin/job-details',
            title: 'menu.jobDetail',
            permission: 'view-job-details'
          },
          {
            path: '/admin/nationalities',
            title: 'menu.nationality',
            permission: 'view-nationalities'
          },
          {
            path: '/admin/employee-status',
            title: 'menu.employeeStatus',
            permission: 'view-employee-status'
          },
          {
            path: '/admin/employees',
            title: 'menu.employee',
            permission: 'view-employees'
          },
          {
            path: '/admin/position-hierarchies',
            title: 'menu.positionHierarchy',
            permission: 'view-position-hierachies'
          },

        ]
      },
      {
        title: 'menu.holidayManagement',
        children: [
          {
            path: '/admin/holiday-rules',
            title: 'menu.holidayRule',
            permission: 'view-holiday-rules'
          },
          {
            path: '/admin/holiday',
            title: 'menu.holiday',
            permission: 'view-holiday'
          }
        ]
      },
      {
        path: '/admin/shift-managements',
        title: 'menu.shiftManagement',
        permission: 'view-shift-managements'
      },
      {
        title: 'menu.leaveManagement',
        children: [
          {
            path: '/admin/leave-sub-items',
            title: 'menu.leaveSubItem',
            permission: 'view-leave-sub-items'
          },
          {
            path: '/admin/leave-rules',
            title: 'menu.leaveRule',
            permission: 'view-leave-rules'
          },
          {
            path: '/admin/leave-initial-balances',
            title: 'menu.leaveInitialBalance',
            permission: 'view-leave-initial-balances'
          },
          {
            path: '/admin/leave-records',
            title: 'menu.leaveRecord',
            permission: 'view-leave-records'
          }
        ]
      },
      {
        title: 'menu.attendanceManagement',
        children: [
          {
            path: '/admin/attendance-devices',
            title: 'menu.attendanceDevice',
            permission: 'view-attendance-devices'
          },
          {
            path: '/admin/employee-card-activators',
            title: 'menu.cardActivator',
            permission: 'view-employee-card-activators'
          },
          {
            path: '/admin/work-schedules',
            title: 'menu.workSchedule',
            permission: 'view-work-schedules'
          },
          {
            path: '/admin/daily-attendances',
            title: 'menu.dailyAttendance',
            permission: 'view-daily-attendances'
          },
          {
            path: '/monthly-attendences',
            title: 'menu.monthlyAttendence',
            permission: 'view-monthly-attendances'
          }
        ]
      }
    ]
  },
  {
    title: 'PROJECT MGT',
    icon: 'fas fa-project-diagram',
    children: [
      {
        path: '/admin/project-managment',
        title: 'menu.projectHome',
        permission: 'view-home-projects'
      },
      {
        path: '/admin/site-profiles',
        title: 'menu.site',
        permission: 'view-site-profiles'
      },
      {
        path: '/admin/project-profiles',
        title: 'menu.projectProfile',
        permission: 'view-project-profiles'
      },
      {
        path: '/admin/tasks',
        title: 'menu.taskProfile',
        permission: 'view-task-profiles'
      }
    ]
  },
  // {
  //   title: 'EMPLOYEE',
  //   icon: 'fas fa-user-tie',
  //   children: [
  //     {
  //       path: '/admin/departments',
  //       title: 'Department',
  //       permission: 'view-departments'
  //     },
  //     {
  //       path: '/admin/positions',
  //       title: 'Position',
  //       permission: 'view-positions'
  //     },
  //     {
  //       path: '/admin/employees',
  //       title: 'Profile',
  //       permission: 'view-employee-profiles'
  //     }
  //   ]
  // },
  // {
  //   title: 'SALE',
  //   icon: 'fas fa-street-view',
  //   children: [
  //     {
  //       path: '/admin/approval-requests',
  //       title: 'Approval Request',
  //       permission: 'view-approval-requests'
  //     },
  //     {
  //       path: '/admin/sale-areas',
  //       title: 'Sale Area',
  //       permission: 'view-sale-areas'
  //     },
  //     {
  //       path: '/admin/visitation-route-plans',
  //       title: 'Shop Visit Plan',
  //       permission: 'view-visitation-route-plans'
  //     },
  //     {
  //       path: '/admin/location-visitations',
  //       title: 'Commune Visit Plan',
  //       permission: 'view-location-visitations'
  //     }
  //   ]
  // },
  {
    title: 'CUSTOMER',
    icon: 'fas fa-users',
    children: [
      {
        path: '/admin/customer-profiles',
        title: 'Profile',
        permission: 'view-customer-profiles'
      }
    ]
  },
  {
    title: 'menu.serviceOrder',
    icon: 'fas fa-tags',
    children: [
      {
        title: 'menu.serviceManagement',
        children: [
          {
            path: '/admin/service-managements',
            title: 'menu.serviceManagementHome',
            permission: 'view-service-managements'
          },
          {
            path: '/admin/service-requests',
            title: 'menu.serviceRequest',
            permission: 'view-service-managements'
          },
        ]
      },
      {
        path: '/admin/order-managements',
        title: 'menu.orderManagement',
        permission: 'view-order-managements'
      }
    ]
  },
  {
    title: 'INVENTORY',
    icon: 'far fa-chart-bar',
    children: [
      {
        path: '/admin/warehourses',
        title: 'Warehouse',
        permission: 'view-warehourses'
      },
      {
        title: 'Product',
        children: [
          {
            path: '/admin/product-categories',
            title: 'Category',
            permission: 'view-product-categories'
          },
          {
            path: '/admin/product-groups',
            title: 'Group',
            permission: 'view-product-groups'
          },
          {
            path: '/admin/suppliers',
            title: 'Supplier',
            permission: 'view-suppliers'
          },
          {
            path: '/admin/uom-categories',
            title: 'UOM Category',
            permission: 'view-uom-categories'
          },
          {
            path: '/admin/product-profiles',
            title: 'Profile',
            permission: 'view-product-profiles'
          },
          {
            path: '/admin/serial-profiles',
            title: 'Serial Profile',
            permission: 'view-serial-profiles'
          },
          {
            path: '/admin/product-assemblies',
            title: 'Assembly',
            permission: 'view-product-assemblies'
          },
          {
            path: '/admin/product-add-on',
            title: 'Add On',
            permission: 'view-product-add-on'
          },
          {
            path: '/admin/product-specifications',
            title: 'Specification',
            permission: 'view-product-specifications'
          },
          {
            path: '/admin/product-locations',
            title: 'Product Warehouse',
            permission: 'view-product-locations'
          },
          {
            path: '/admin/product-prices',
            title: 'Price',
            permission: 'view-product-prices'
          },
          {
            path: '/admin/product-costs',
            title: 'Cost',
            permission: 'view-product-costs'
          },
          // {
          //   path: '/admin/product-pallets',
          //   title: 'Pallet',
          //   permission: 'view-product-pallets'
          // },
          {
            path: '/admin/product-labels',
            title: 'Generate Label',
            permission: 'view-generate-lables'
          },
          {
            path: '/admin/product-histories',
            title: 'History',
            permission: 'view-product-histories'
          }
        ]
      },
      {
        path: '/admin/stock-confirm',
        title: 'Stock Confirmation',
        permission: 'view-stock-confirm'
      },
      {
        path: '/admin/stock-counts',
        title: 'Stock Count',
        permission: 'view-stock-counts'
      },
      // {
      //   path: '/admin/stock-transfers',
      //   title: 'Stock Transfer',
      //   permission: 'view-stock-transfers'
      // },
      {
        path: '/admin/transfer-by-serials',
        title: 'Stock Transfer',
        permission: 'view-transfer-by-serials'
      },
      {
        path: '/admin/stock-return',
        title: 'Stock Return',
        permission: 'view-stock-return'
      },
      {
        path: '/admin/stock-adjustments',
        title: 'Stock adjustment',
        permission: 'view-stock-adjustments'
      },
      {
        path: '/admin/inventory-lists',
        title: 'Inventory List',
        permission: 'view-inventory-lists'
      },
      {
        path: '/admin/summary-inventory-lists',
        title: 'Summary Inventory List',
        permission: 'view-summary-inventory-lists'
      },
      {
        path: '/admin/spare-part-replacements',
        title: 'Spare Part Replacement',
        permission: 'view-spare-part-replacements'
      },
      {
        path: '/admin/write-offs',
        title: 'Write-off',
        permission: 'view-write-offs'
      },
      {
        path: '/admin/purchase-requests',
        title: 'Purchase Request',
        permission: 'view-purchase-requests'
      }
    ]
  },
  {
    icon: 'fas fa-coins',
    title: 'menu.accounting',
    children: [
      {
        path: '/admin/coa-categories',
        title: 'menu.coaCategory',
        permission: 'view-coa-categories'
      },
      {
        path: '/admin/coa-setups',
        title: 'menu.coaSetup',
        permission: 'view-coa-setups'
      },
      {
        path: '/admin/coa-mappings',
        title: 'menu.coaMapping',
        permission: 'view-coa-mappings'
      },
      {
        path: '/admin/journal-entries',
        title: 'menu.journalEntry',
        permission: 'view-journal-entries'
      },
      {
        path: '/admin/general-ledgers',
        title: 'menu.generalLedger',
        permission: 'view-general-ledgers'
      },
      {
        path: '/admin/trial-balances',
        title: 'menu.trialBalance',
        permission: 'view-trial-balances'
      },
      {
        path: '/admin/income-statements',
        title: 'menu.incomeStatement',
        permission: 'view-income-statements'
      },
      {
        path: '/admin/balance-sheets',
        title: 'menu.balanceSheet',
        permission: 'view-balance-sheets'
      }
    ]
  },
  {
    title: 'FINANCE',
    icon: 'fas fa-chart-line',
    children: [
      {
        title: 'Purchase Order',
        path: '/admin/purchase-orders',
        permission: 'view-purchase-orders'
      },
      {
        path: '/admin/stock-in',
        title: 'Purchase Invoice',
        permission: 'view-stock-in'
      },
      {
        path: '/admin/trade-in',
        title: 'Trade In',
        permission: 'view-stock-in'
      },
      {
        path: '/admin/payment-vendors',
        title: 'Pay to vendor',
        permission: 'view-pay-to-vendors'
      },
      {
        path: '/admin/quotations',
        title: 'Quotation',
        permission: 'view-quotations'
      },
      {
        path: '/admin/sale-contracts',
        title: 'Sale Contract',
        permission: 'view-sale-contracts'
      },
      {
        path: '/admin/borrowing-spare-parts',
        title: 'Borrowing Spare-part',
        permission: 'view-borrowing-spare-parts'
      },
      {
        path: '/admin/whole-sales',
        title: 'Sale Invoice',
        permission: 'view-whole-sales'
      },
      {
        path: '/admin/delivery-orders',
        title: 'Delivery Order',
        permission: 'view-delivery-orders'
      },
      {
        path: '/admin/wholesale-receipts',
        title: 'Receipt',
        permission: 'view-wholesale-receipts'
      },
      {
        path: '/admin/return-to-vendors',
        title: 'Return to vendor',
        permission: 'view-return-to-vendors'
      },
      {
        path: '/admin/return-from-vendors',
        title: 'Return from vendor',
        permission: 'view-return-from-vendors'
      },
      {
        path: '/admin/stock-closes',
        title: 'Close Stock',
        permission: 'view-stock-closes'
      }
    ]
  },
  {
    title: 'BOOKING',
    icon: 'fas fa-user-clock',
    children: [
      {
        path: '/admin/table-profiles',
        title: 'Table Profile',
        permission: 'view-table-profiles'
      },
      {
        path: '/admin/available-schedules',
        // title: 'Available Schedule', boss need to change
        title: 'Service Hour',
        permission: 'view-available-schedules'
      },
      {
        path: '/admin/table-bookings',
        title: 'Table Booking',
        permission: 'view-table-bookings'
      }
    ]
  },
  {
    title: 'RETAIL SALE',
    icon: 'fas fa-cart-plus',
    children: [
      {
        path: '/admin/product-price-schema',
        title: 'Product Price Schema',
        permission: 'view-product-price-schema'
      },
      {
        path: '/admin/counters',
        title: 'Counter',
        permission: 'view-counters'
      },
      {
        path: '/admin/kot-bot-printers',
        title: 'KOT/BOT Printer',
        permission: 'view-kot-bot-printers'
      },
      {
        path: '/admin/mart-sales',
        title: 'Point-of-sale',
        permission: 'view-mart-sales'
      },
      {
        path: '/admin/mart-sales/lists',
        title: 'Sale List',
        permission: 'view-mart-sales'
      },
      {
        path: '/admin/deleted-items/lists',
        title: 'Deleted Items List',
        permission: 'view-deleted-items-list',
      },
      {
        path: '/admin/pos/counter-checkouts-orders',
        title: 'Restaurant Order',
        permission: 'view-restaurant-orders'
      },
      {
        path: '/admin/pos/counter-checkouts',
        title: 'Restaurant Sale',
        permission: 'view-restaurant-sales'
      },
      {
        path: '/admin/pos/restaurant-sales',
        title: 'Sale List',
        permission: 'view-restaurant-sales'
      },
      {
        path: '/admin/sale-product-deleted',
        title: 'Sale Product Deleted',
        permission: 'view-sale-product-deleted'
      },
      {
        path: '/admin/restaurant-kdu',
        title: 'View KDU',
        permission: 'view-kitchen-display-units'
      }
    ]
  },
  {
    title: 'EXPENSE',
    icon: 'fas fa-file-invoice-dollar',
    children: [
      {
        path: '/admin/daily-cash-advances',
        title: 'Daily Cash Advance',
        permission: 'view-daily-cash-advances'
      },
      {
        path: '/admin/expense-categories',
        title: 'Category',
        permission: 'view-expense-categories'
      },
      {
        path: '/admin/expense-items',
        title: 'Expense Item',
        permission: 'view-expense-items'
      },
      {
        path: '/admin/daily-expenses',
        title: 'Daily Expense',
        permission: 'view-daily-expenses'
      },
      {
        path: '/admin/expense-postings',
        title: 'Expense Posting',
        permission: 'view-expense-postings'
      }
    ]
  },
  {
    title: 'PAYROLL',
    icon: 'fas fa-hand-holding-usd',
    children: [
      { path: '/admin/nssf', title: 'menu.nssf', permission: 'view-nssf' },
      {
        title: 'menu.setup',
        children: [
          {
            path: '/admin/payroll-cycle-dates',
            title: 'Payroll Cycle Date',
            permission: 'view-payroll-cycle-dates'
          },
          {
            path: '/admin/pay-user-variables',
            title: 'Payroll Formula',
            permission: 'view-pay-user-variables'
          },
          {
            path: '/admin/basic-salary-formulas',
            title: 'Basic Salary Formula',
            permission: 'view-basic-salary-formulas'
          },
          {
            path: '/admin/basic-salarys',
            title: 'Basic Salary',
            permission: 'view-basic-salarys'
          },
          {
            path: '/admin/payroll-cycles',
            title: 'Payroll Cycle',
            permission: 'view-payroll-cycles'
          },
          // {
          //   path: '/admin/tax-ranges',
          //   title: 'menu.taxRange',
          //   permission: 'view-tax-ranges'
          // },
          {
            title: 'menu.payrollItems',
            children: [
              {
                path: '/admin/allowance-items',
                title: 'menu.allowanceItem',
                permission: 'view-item-allowances'
              },
              {
                path: '/admin/deduction-items',
                title: 'Item Deduction',
                permission: 'view-item-deductions'
              },
              {
                path: '/admin/compensation-items',
                title: 'menu.compensationItem',
                permission: 'view-item-compensates'
              },
              {
                path: '/admin/incentive-bonus-items',
                title: 'Item Incentive/Bonus',
                permission: 'view-item-incentive-bonus'
              },
              {
                path: '/admin/item-overtimes',
                title: 'Item Overtime',
                permission: 'view-item-overtimes'
              }
            ]
          },
          {
            path: '/admin/overtime-rule-by-shifts',
            title: 'menu.otRuleByShift',
            permission: 'view-overtime-rule-by-shifts'
          },
          {
            path: '/admin/payroll-templates',
            title: 'menu.payrollTemplate',
            permission: 'view-payroll-templates'
          },
          {
            path: '/admin/payslip-templates',
            title: 'menu.payslipTemplate',
            permission: 'view-payslip-templates'
          },
          {
            path: '/admin/tax-ranges',
            title: 'menu.taxRang',
            permission: 'view-tax-ranges'
          }
        ]
      },
      {
        title: 'menu.operation',
        children: [
          {
            path: '/admin/fixed-allowances',
            title: 'menu.fixedAllowance',
            permission: 'view-fixed-allowances'
          },
          {
            path: '/admin/fixed-incentive-bonus',
            title: 'menu.fixedIncentiveBonus',
            permission: 'view-fixed-incentive-bonus'
          },
          {
            path: '/admin/monthly-allowances',
            title: 'menu.monthlyAllowance',
            permission: 'view-monthly-allowances'
          },
          {
            path: '/admin/monthly-deductions',
            title: 'menu.monthlyDeduction',
            permission: 'view-monthly-deductions'
          },
          {
            path: '/admin/monthly-incentive-bonus',
            title: 'menu.monthlyIncentiveBonus',
            permission: 'view-monthly-incentive-bonus'
          },
          {
            path: '/admin/monthly-compensates',
            title: 'menu.monthlyCompensate',
            permission: 'view-monthly-compensates'
          },
          {
            path: '/admin/monthly-over-times',
            title: 'menu.monthlyOvertime',
            permission: 'view-monthly-overtimes'
          },
          {
            path: '/admin/payroll-calculations',
            title: 'menu.payrollCalculation',
            permission: 'view-payroll-calculations'
          },
          {
            path: '/admin/first-cycle-paids',
            title: 'menu.firstCyclePaid',
            permission: 'view-first-cycle-paids'
          }
        ]
      }
    ]
  },
  {
    title: 'REPORT',
    icon: 'fas fa-file-invoice',
    children: [
      {
        title: 'Accounting',
        children: [
          {
            path: '/admin/report/general-journal-records',
            title: 'menu.generalJournalRecord',
            permission: 'view-report-general-journal-records'
          },
          {
            path: '/admin/report/general-ledgers',
            title: 'menu.generalLedger',
            permission: 'view-report-general-ledgers'
          },
          {
            path: '/admin/report/trial-balances',
            title: 'menu.trialBalance',
            permission: 'view-report-trial-balances'
          },
          {
            path: '/admin/report/balance-sheets',
            title: 'menu.balanceSheet',
            permission: 'view-report-balance-sheets'
          },
          {
            path: '/admin/report/profit-and-losses',
            title: 'menu.profitAndLoss',
            permission: 'view-report-profit-and-losses'
          }
        ]
      },
      {
        title: 'menu.serviceOrder',
        children: [
          {
            path: '/admin/report/service-requests',
            title: 'menu.serviceRequest',
            permission: 'view-report-service-requests'
          },
        ]
      },
      {
        title: 'Inventory',
        children: [
          {
            title: 'menu.stockInReport',
            children: [
              {
                path: '/admin/report/stock-in-details',
                title: 'Stock In Detail',
                permission: 'view-stock-in-details'
              },
              {
                path: '/admin/report/stock-in-summaries',
                title: 'Stock In Summary',
                permission: 'view-stock-in-summaries'
              }
            ]
          },
          {
            path: '/admin/report/detail-inventory-lists',
            title: 'Detail Inventory List',
            permission: 'view-detail-inventory-lists'
          },
          {
            path: '/admin/report/summary-inventory-lists',
            title: 'Summary Inventory List',
            permission: 'view-summary-inventory-lists'
          },
          {
            path: '/admin/report/product-item-lists',
            title: 'Product Price List',
            permission: 'view-product-item-lists'
          },
          {
            path: '/admin/report/purchase-order-lists',
            title: 'PO List',
            permission: 'view-purchase-order-lists'
          },
          {
            path: '/admin/report/purchase-order-summaries',
            title: 'PO Summary',
            permission: 'view-purchase-order-summaries'
          },
          {
            path: '/admin/report/monthly-sale-items',
            title: 'Monthly Sale Item',
            permission: 'view-monthly-sale-items'
          },
          {
            path: '/admin/report/stock-transfers',
            title: 'Stock Transfer',
            permission: 'view-stock-transfer-reports'
          },
          {
            path: '/admin/report/yearly-sale-items',
            title: 'Yearly Sale Item',
            permission: 'view-yearly-sale-items'
          },
          {
            path: '/admin/report/inventory/product-lists',
            title: 'Product List',
            permission: 'view-report-product-lists'
          },
          {
            path: '/admin/report/inventory/product-serials',
            title: 'Product Serial',
            permission: 'view-report-product-serials'
          },
          {
            path: '/admin/report/inventory/product-addon-info',
            title: 'Product Addon/Sparepart Info',
            permission: 'view-product-add-on'
          },
          {
            path: '/admin/report/inventory/product-non-moving-stock',
            title: 'Product Non Moving Stock',
            permission: 'view-product-non-moving-stock'
          },
          {
            path: '/admin/report/inventory/inventory-min-max',
            title: 'Inventory Min Max',
            permission: 'view-inventory-min-max-report'
          },
          {
            path: '/admin/report/inventory/inventory-min-max-2',
            title: 'Inventory Min Max 2',
            permission: 'view-inventory-min-max-2-report'
          },
          {
            path: '/admin/report/inventory/product-warranty-expireds',
            title: 'Product Warranty Expired',
            permission: 'view-product-warranty-expired-report'
          },
          {
            path: '/admin/report/inventory/inventory-list-by-warehouses',
            title: 'Inventory List By Warehouse',
            permission: 'view-inventory-list-by-warehouse-report'
          },
          {
            path: '/admin/report/stock-adjustments',
            title: 'Stock Adjustment',
            permission: 'view-stock-adjustment-report'
          },
          {
            path: '/admin/report/stock-returns',
            title: 'Stock Return',
            permission: 'view-stock-return-report'
          },
          {
            path: '/admin/report/detail-transfers',
            title: 'Detail Transfer by IMEI/Serial',
            permission: 'view-detail-transfer-reports'
          },
          {
            path: '/admin/report/transfer-pending-status',
            title: 'Transfer Pending Status',
            permission: 'view-transfer-pending-status-reports'
          }
        ]
      },
      {
        title: 'Finance',
        children: [
          {
            title: 'menu.incomeRreport',
            children: [
              {
                path: '/admin/reports/incomes',
                title: 'Daily Income By Cashier',
                permission: 'view-daily-incomes'
              },
              {
                path: '/admin/reports/income-by-sales',
                title: 'Daily Income By Sale',
                permission: 'view-daily-income-by-sales'
              },
              {
                path: '/admin/reports/finance/income-statement-details',
                title: 'Income Statement Detail',
                permission: 'view-report-income-statement-details'
              }
            ]
          },
          // {
          //   path: '/admin/reports/daily-cash-flow-and-stocks',
          //   title: 'Daily Cash Flow & Stock Control',
          //   permission: 'view-daily-cash-flow-and-stocks'
          // },
          {
            path: '/admin/reports/sale-items',
            title: 'Daily Sale Item',
            permission: 'view-daily-sale-items'
          },
          {
            title: 'Payment To Vendors',
            children: [
              {
                path: '/admin/reports/finance/pay-to-vendors',
                title: 'Pay To Vendor',
                permission: 'view-report-pay-to-vendors'
              },
              {
                path: '/admin/reports/finance/account-payables',
                title: 'Account Payable',
                permission: 'view-account-payable-reports'
              }
            ]
          },
          {
            title: 'Gross Profit',
            children: [
              {
                path: '/admin/reports/finance/gross-profit-product',
                title: 'Gross Profit Product',
                permission: 'view-report-gross-profits'
              },
              {
                path: '/admin/reports/finance/gross-profit-customer',
                title: 'Gross Profit Customer',
                permission: 'view-gross-profit-customers'
              }
            ]
          },
          // {
          //   path: '/admin/reports/finance/product-prices',
          //   title: 'Product Price',
          //   permission: 'view-report-product-prices'
          // },
          {
            path: '/admin/reports/finance/account-receivables',
            title: 'Account Receivable',
            permission: 'view-account-receivables'
          },
          {
            path: '/admin/reports/finance/cash-collections',
            title: 'Cash Collection By Cashier',
            permission: 'view-cash-collection'
          },
          {
            path: '/admin/reports/finance/cash-collection-restaurant-sales',
            title: 'Cash Collection By Cashier',
            permission: 'view-cash-collection-restaurant-sales'
          },
          {
            path: '/admin/reports/finance/yearly-sold-by-sale-types',
            title: 'Yearly Sold By Sale Type',
            permission: 'view-yearly-sold-by-sale-types'
          },
          {
            path: '/admin/reports/finance/customer_sales_by_months',
            title: 'Customer Sales By Month',
            permission: 'view-customer_sales_by_months'
          },
          {
            path: '/admin/reports/finance/sale-contracts',
            title: 'Sale Contract',
            permission: 'view-sale-contract-reports'
          },
          {
            path: '/admin/reports/finance/monthly-report-summarys',
            title: 'Monthly Sale Report',
            permission: 'view-monthly-sale-report'
          },
          {
            path: '/admin/reports/finance/transaction-back-dates',
            title: 'Transaction Back Date',
            permission: 'view-transection-back-dates'
          }
        ]
      },
      {
        title: 'Expense',
        children: [
          {
            path: '/admin/reports/expense/daily-expenses',
            title: 'Daily Expense',
            permission: 'view-daily-expense-reports'
          },
          {
            path: '/admin/reports/expense/daily-cash-advances',
            title: 'Daily Cash Advance',
            permission: 'view-daily-cash-advance-reports'
          },
          {
            path: '/admin/reports/yearly-expense-items',
            title: 'Yearly Expense Item',
            permission: 'view-yearly-expense-items'
          },
          {
            path: '/admin/reports/monthly-expense-items',
            title: 'Monthly Expense Item',
            permission: 'view-monthly-expense-items'
          }
        ]
      },
      {
        title: 'Sale',
        children: [
          {
            path: '/admin/reports/sale/visitation-plans',
            title: 'Visitation Plan',
            permission: 'view-visitation-plan-reports'
          },
          {
            path: '/admin/reports/sale/detail-sale-by-products',
            title: 'Detail Sale By Product',
            permission: 'view-detail-sale-by-product-reports'
          },
          {
            path: '/admin/reports/sale/detail-sale-by-customers',
            title: 'Detail Sale By Customer',
            permission: 'view-detail-sale-by-customer-reports'
          },
          {
            path: '/admin/reports/sale/detail-stock-return-by-products',
            title: 'Detail Stock Return By Product',
            permission: 'view-detail-stock-return-by-product-reports'
          },
          {
            path: '/admin/reports/sale/detail-sale-by-imeis',
            title: 'Detail Sale By Imei',
            permission: 'view-detail-sale-by-imei-reports'
          }
        ]
      },
      {
        title: 'menu.humanResource',
        children: [
          {
            path: '/admin/report/attendance-details',
            title: 'menu.attendanceDetail',
            permission: 'view-attendance-details'
          },
          {
            path: '/admin/report/attendance-summaries',
            title: 'menu.attendanceSummary',
            permission: 'view-attendance-summaries'
          },
          {
            path: '/admin/report/leave-balances',
            title: 'menu.leaveBalance',
            permission: 'view-report-leave-balances'
          },
          {
            path: '/admin/report/employee-profiles',
            title: 'menu.employeeProfile',
            permission: 'view-report-employee-profiles'
          },
          {
            path: '/admin/report/attendance-galleries',
            title: 'menu.attendanceGallery',
            permission: 'view-attendance-galleries'
          },
          {
            path: '/admin/report/leave-report',
            title: 'menu.leaveReport',
            permission: 'view-leave-report-summary'
          }
        ]
      },
      {
        title: 'menu.payroll',
        children: [
          {
            path: '/admin/report/payroll-details',
            title: 'menu.payrollDetail',
            permission: 'view-payroll-details'
          },
          {
            path: '/admin/report/basic-salary-historys',
            title: 'menu.BasicSlaryHistory',
            permission: 'view-basic-salary-histories'
          },
          {
            path: '/admin/report/nssf-reports',
            title: 'menu.NssfReport',
            permission: 'view-nssf-reports'
          },
          {
            path: '/admin/report/payslip',
            title: 'menu.payslip',
            permission: 'view-report-payslips'
          },
          {
            path: '/admin/report/summary-pension-and-insurances',
            title: 'menu.summaryPensionAndInsurance',
            permission: 'view-report-payslips'
          }
        ]
      },
      {
        title: 'menu.projectMGT',
        children: [
          {
            path: '/admin/report/daily-item-used-reports',
            title: 'menu.dailyItemUsedReport',
            permission: 'view-report-daily-item-useds'
          },
          {
            path: '/admin/report/daily-task-updates',
            title: 'Daily Task Update',
            permission: 'view-report-daily-task-updates'
          }
        ]
      }
    ]
  },
  {
    title: 'SECURITY',
    icon: 'fab fa-expeditedssl',
    children: [
      { path: '/admin/roles', title: 'Role', permission: 'view-roles' },
      { path: '/admin/users', title: 'User', permission: 'view-users' },
      {
        path: '/admin/login-out',
        title: 'Login/Out',
        permission: 'view-login-out'
      }
    ]
  }
]
